<template>
  <WorkBasicDialog
    ref="workBasicDialog"
    content-class="w-help-dialog"
    width="xl"
    height="xl"
  >
    <template #header>
      {{ $t('Common.help') }}
    </template>

    <template
      #content-wrapper
      style="height: 100%"
    >
      <TabsComponent
        v-model="currentTab"
        :help-tabs="helpTabs"
      />
    </template>

    <template #dialog-actions="{ close }">
      <w-btn @click="close">
        {{ $t('Common.close') }} 
      </w-btn>
    </template>
  </WorkBasicDialog>
</template>

<script>
// components
import TabsComponent from './HelpTabsComponent'
import WorkBasicDialog from "@/components/base_components/dialog/WorkBasicDialog";

// utils
import HELP_TABS from "@/modules/help/data/HELP_TABS";

const byId = (helpTabId) => (tab) => tab.id === helpTabId;

export default {
  components: { WorkBasicDialog, TabsComponent },
  data() {
    return {
      currentTab: 0,
      helpTabs: HELP_TABS
    }
  },
  mounted() {
    // window.redirectInnerHelp = (id) => this.innerHelpHandler(id);  //DISABLED (FOR NOW) DUE TO MEMORY LEAK
  },
  methods: {
    open(moduleId) {
      this.innerHelpHandler(moduleId);
      return this.$refs.workBasicDialog.open();
    },
    innerHelpHandler(helpTabId) {
      let index = this.helpTabs.findIndex(byId(helpTabId));
      if (index >= 0) { this.currentTab = index; }
    },
  },
};
</script>

<style lang="scss">
.w-help-dialog  {
  .w-dialog-content {
    padding: 0 !important;

    .dialog-content {
      height: 100%;
      .v-tabs-bar, 
      .v-window, 
      .v-window .v-card {
        background-color: var(--v-work_card-base);
      }
    }
  }


  &__tabs-wrapper div {
    height: 100%;
  }
}
</style>
